import React from 'react';
import { Heading3 } from '@qover/typography';
import { Container, HeaderContainer } from './Card';
import AdultFaceIcon from './icons/AdultFaceIcon';
import {
  BirthdateField,
  FirstNameField,
  LastNameField,
  TitleField,
} from './FormFields';

export function AdultCard({
  'data-test': dataTest,
  gender = true,
  prefix,
  title,
}: {
  'data-test': string;
  gender: boolean;
  prefix: string;
  title: React.ReactNode;
}) {
  return (
    <Container>
      {title && (
        <HeaderContainer>
          <AdultFaceIcon />
          <Heading3>{title}</Heading3>
        </HeaderContainer>
      )}
      {gender && <TitleField prefix={prefix} data-test={dataTest} />}
      <FirstNameField prefix={prefix} data-test={dataTest} />
      <LastNameField prefix={prefix} data-test={dataTest} />
      <BirthdateField prefix={prefix} data-test={dataTest} />
    </Container>
  );
}
